export default function CTASection() {
  return (
    <section className="relative w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center">
          <div className="relative w-full mb-10 rounded-2xl overflow-hidden">
            <div className="relative w-full aspect-[21/9] md:aspect-[21/7]">
              <img
                src="https://readdy.ai/api/search-image?query=Stylish%20fashion%20and%20accessories%20flat%20lay%20with%20sneakers%20bags%20caps%20and%20jewelry%20arranged%20on%20warm%20sand%20colored%20surface%2C%20soft%20golden%20hour%20sunlight%20streaming%20from%20window%2C%20editorial%20product%20photography%2C%20warm%20terracotta%20and%20cream%20tones%2C%20gentle%20natural%20shadows%2C%20harmonious%20composition%2C%20high%20detail%20textures%2C%20modern%20aesthetic&width=1400&height=600&seq=cta-product-2026-v2&orientation=landscape"
                alt="USFansSpreadsheet - produkty"
                className="w-full h-full object-cover object-center"
                loading="lazy"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/25 to-transparent"></div>
          </div>

          <p className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3 leading-tight">
            Gotowy, aby odkryć <span className="italic text-primary-600">USFansSpreadsheet</span>?
          </p>
          <p className="text-sm md:text-base text-foreground-600 mb-8 max-w-xl mx-auto">
            Sprawdź wszystkie kategorie produktów na kaspreadsheet.com i znajdź najlepsze okazje już dziś.
          </p>

          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-4 bg-foreground-900 text-background-50 text-base font-semibold rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Przejdź do kaspreadsheet.com
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}